import {
  Button,
  CardBody,

  Input,
  Spinner,

  Tooltip,
  Typography,
} from "@material-tailwind/react"
import React, { useEffect, useState, useMemo } from "react"
import {
  CustomDeleteModal,
  DetailDrawer,

} from "../../../components"
import { DEFAULTPRIMARYCOLOR } from "../../../util"

import { AdminType, UpdateType } from "../../../types/admin"
import { toast } from "react-toastify"
import { UserType } from "../../../types/user"
import { DASHBOARD_USERTYPE } from "../../../types/role"
import { useForm } from "react-hook-form"

import { CustomHeader } from "../../../components/headers/CustomHeader"
import { useHistory } from "react-router-dom"
import { useQuery, useLazyQuery } from "@apollo/client"
import { GETPAYMENTREQUISITIONDetail, GETCONSOLIDATEDPAYMENT_REQUISITION } from "../../../GraphQl/queries"
import ConfirmationDialog from "../../../config/confirmationbox"
import { DriverModal } from "../../../components/modal/DriverModal"
import DisApproveOrdres from "../../../components/Details/disaprovePaymentOrders"
import PaymentOrderDetail from "../../../components/Details/payment-order-drawer"
import moment from "moment"
import { FiDownloadCloud } from "react-icons/fi"
import Papa from "papaparse"
import Otp from "../../../components/modal/enterOtpModal"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { getColorCode } from "../../../colorCodes"
import PerPageAndPagination from "../../../components/paginations/perpageAndPagination"
import dayjs from "dayjs";

type AccountDetails = {
  code: string
  branch: string
  bank_name: string
  acct_number: string
  account_name: string
}
type MomoDetails = {
  network: string
  number: string
}

type RequisitionType = {
  account_details: string
  momo_details: string
  amount_requisitioned: number
  policy_number: string
  created_at: string
  id: string
  insurance_company_id: string
  payee_details: string
  payee_id: string
  payee_name: string
  payee_number: string
  payee_type: string
  payment_stage: string
  provider_transaction_id: string
  policy_id: string
  rate: string
  transaction_type: string
  sub_class_name: string
  business_class_name: string
  risk_id: string
  reference: string
  reference_amount: string
  // amount_requisitioned: string;
  transaction_name: string
}



const PaymentOrders = () => {
  const history = useHistory()
  const [user, setUser] = useState<UserType>()
  const [requistionText, setRequistionSearch] = useState("")
  const [loading, setLoading] = useState(false)
  const [showDeleteModal, SetShowDeleteModal] = useState(false)
  const [open, setOpen] = useState(false)
  const [openDrawer, setOpenDrawer] = React.useState(false)
  const [selectedRow, setSelectedRow] = useState<UpdateType>()
  const [selectedRows, setSelectedRows] = useState<string[]>([])
  const [showUpdateModal] = useState(false)
  const [loadingCreating, setLoadingCreating] = useState(false)
  const [openSendDispproveMsg, setOpenSendDispproveMsg] = useState(false)
  const [loadingRow, setLoadingRow] = useState("")
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [chosenId, setChosenId] = useState<RequisitionType>()
  const [selectedRowss, setSelectedRowss] = useState<RequisitionType>()
  const [requestType, setRequestType] = useState("")
  const [openOtp, setOpenOtp] = useState(false)
  const [requisitionId, setRequisitionId] = useState("")

  const defaultStart = moment().subtract(1, "months").format("YYYY-MM-DDTHH:mm");
  const defaultEnd = moment().format("YYYY-MM-DDTHH:mm");
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [tempStartDate, setTempStartDate] = useState(defaultStart);
  const [tempEndDate, setTempEndDate] = useState(defaultEnd);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState<RequisitionType[] | undefined>(undefined)
  const [searchFilterStart, setSearchFilterStart] = useState("");
  const [searchFilterEnd, setSearchFilterEnd] = useState("");

  const [bgTaskStatus, setBgTaskStatus] = useState<{
    running: boolean;
    total: number;
    processed: number;
    success: number;
    failed: number;
  }>({
    running: false,
    total: 0,
    processed: 0,
    success: 0,
    failed: 0,
  })



  const {
    companyId,

    user: stateUser,
    token: stateToken,
  } = useSelector((state: RootState) => state.auth)

  const handleStartDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
    setStartDate(formattedValue)
  }

  const handleEndDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
    setEndDate(formattedValue)
  }

  const handleTempStartDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const dateOnly = value.split("T")[0]; // Extract just the date part
      const formattedValue = `${dateOnly}T00:00`; // Set time to 12:00 AM
      setTempStartDate(formattedValue);
    }
  }

  const handleTempEndDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const formattedValue = value
      setTempEndDate(formattedValue)
    }
  }


  const handleDateChange = () => {
    const start = dayjs(tempStartDate);
    const end = dayjs(tempEndDate);
    const diffInMonths = end.diff(start, 'month', true);

    setIsFilterLoading(true);
    if (searchData !== undefined) {
      setSearchFilterStart(tempStartDate)
      setSearchFilterEnd(tempEndDate)
      setIsFilterLoading(false);
    } else {
      if (diffInMonths > 3) {
        setTempStartDate(defaultStart);
        setTempEndDate(defaultEnd);
        toast.error("Date range cannot exceed 3 months.");
        setIsFilterLoading(false);
        return;
      }

      setTimeout(() => {
        fetchData({
          variables: {
            id: companyId,
            code: "BDD",
            start_date: tempStartDate,
            end_date: tempEndDate
          }
        });
        setIsFilterLoading(false);
      }, 1000);
    }
  };

  const reset = () => {
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setSearchFilterStart("");
    setSearchFilterEnd("");
    if (searchData === undefined) {
      fetchData({
        variables: {
          id: companyId,
          code: "BDD",
          start_date: defaultStart,
          end_date: defaultEnd
        }
      });
    }
  }



  const defaultValues = useMemo(() => {
    return {
      ...selectedRow,
    }
  }, [selectedRow])

  const {

    setValue,

  } = useForm<UpdateType>({
    defaultValues: defaultValues,
  })

  const [fetchData, {
    data: requisition,
    loading: loadingRequistion,
    refetch: refetchRequisition,
  }] = useLazyQuery<{
    view_payment_requistion_details: RequisitionType[]
    payment_requisition: any
  }>(GETCONSOLIDATEDPAYMENT_REQUISITION, {
    variables: {
      id: companyId,
      code: "BDD",
    },
    fetchPolicy: "network-only"
  })

  useEffect(() => {
    fetchData({
      variables: {
        id: companyId,
        code: "BDD",
        start_date: defaultStart,
        end_date: defaultEnd
      }
    });
  }, [companyId]);


  useEffect(() => {
    const handleFocus = () => {
      refetchRequisition();
    };

    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [refetchRequisition]);


  const parseRequisitionData = (data: RequisitionType) => {
    const parsedAccountDetails: AccountDetails = JSON.parse(
      data.account_details
    )
    const parsedMomoDetails: MomoDetails = JSON.parse(data.momo_details)

    return {
      ...data,
      account_details: parsedAccountDetails,
      momo_details: parsedMomoDetails,
    }
  }



  const handleRequistionSerach = () => {
    search()
  }


  const search = async () => {
    if (requistionText) {
      try {
        setIsFilterLoading(true)
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/search-i2i-payment-orders?company_id=${companyId}&search_term=${requistionText}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${stateToken}`,
            },
          }
        )

        const req = await response.json()

        if (response.ok) {
          // console.log(req)
          setSearchData(req.data)
          toast.success(req?.message)
        } else {
          // setSearchData("")
          toast.error(req?.message)
        }
        setIsFilterLoading(false)
      } catch (error) {
        // setSearchData("")
        toast.error("Could not perform search")
        setIsFilterLoading(false)
      }
    }
  }


  const filterRequisition = (data: RequisitionType) => {
    const date = moment(data.created_at).format("LL")
    const isTextMatch =
      data?.payee_name
        ?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      parseRequisitionData(data)
        .account_details.bank_name?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      parseRequisitionData(data)
        .account_details.account_name?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      data?.policy_number
        ?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      data?.risk_id?.toLowerCase()?.includes(requistionText?.toLowerCase()) ||
      data?.sub_class_name
        ?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      parseRequisitionData(data)
        .momo_details.network?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      parseRequisitionData(data)
        .momo_details.number?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      data?.account_details
        ?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      data?.provider_transaction_id
        ?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      data?.transaction_name
        ?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      data?.transaction_type
        ?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      data?.amount_requisitioned
        .toString()
        ?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      data?.reference?.toLowerCase()?.includes(requistionText?.toLowerCase()) ||
      data?.payee_number
        ?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      data?.payment_stage
        ?.toLowerCase()
        ?.includes(requistionText?.toLowerCase()) ||
      date?.toLowerCase()?.includes(requistionText?.toLowerCase()) ||
      data?.rate?.toLowerCase()?.includes(requistionText?.toLowerCase())
    return isTextMatch
  }

  function filterDate(item: RequisitionType): boolean {
    const date = new Date(item?.created_at);
    const start = new Date(searchFilterStart);
    const end = new Date(searchFilterEnd);

    return date >= start && date <= end;
  }

  const [currentPage, setCurrentPage] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  useEffect(() => {
    if (requistionText || startDate || endDate || itemsPerPage) {
      setCurrentPage(0)
    }
  }, [requistionText, startDate, endDate, itemsPerPage])


  const displayData = searchData !== undefined ? searchData : requisition?.view_payment_requistion_details
  const totalItems = (searchFilterStart || searchFilterEnd) ? displayData?.filter(filterDate) : displayData




  // ?.filter(filterRequisition) : [];
  // ?.filter((item: any) => {
  //   const normalizeDate = (date: Date | string): Date => {
  //     const normalizedDate = new Date(date)
  //     normalizedDate.setHours(0, 0, 0, 0) // Set time to midnight to include the entire day
  //     return normalizedDate
  //   }
  //   const from =
  //     (startDate as any) instanceof Date
  //       ? normalizeDate(startDate)
  //       : normalizeDate(startDate)
  //   const to =
  //     (endDate as any) instanceof Date
  //       ? normalizeDate(endDate)
  //       : normalizeDate(endDate)
  //   const dateCreated = normalizeDate(item.created_at)

  //   // Convert date_created to Date object
  //   // Check if dateCreated falls within the range (inclusive)
  //   if (startDate && endDate) {
  //     return dateCreated >= from && dateCreated <= to // Corrected to <= for endDate
  //   } else if (startDate) {
  //     return dateCreated >= from // Only from date is set
  //   } else if (endDate) {
  //     return dateCreated <= to // Only to date is set
  //   }
  //   return true // No filter applied
  // })

  // const paginatedData = totalItems?.slice(startIndex, endIndex)

  const endOffset = currentPage + itemsPerPage
  const paginatedData = totalItems?.slice(currentPage, endOffset)



  const handleDownload = () => {
    // Check if there is data to download
    if (paginatedData?.length === 0) {
      alert("No data to download.")
      return
    }
    // Define custom headers based on the selected filter

    const type = paginatedData?.map((item: RequisitionType) => ({

      "bank name": JSON.parse(item?.account_details)?.bank_name,
      "bank branch": JSON.parse(item?.account_details)?.branch,
      "momo network": JSON.parse(item?.momo_details)?.network,
      "momo number": JSON.parse(item?.momo_details)?.number,
      "amount requisitioned": item?.amount_requisitioned,
      "policy number": item?.policy_number,
      "created at": moment(item?.created_at).format("LL"),

      "insurance company id": item?.insurance_company_id,
      "payee name": item?.payee_name,
      "payee type": item?.payee_type,
      "payee number": item?.payee_number,


    }))
    const firstItem = type![0]
    const originalHeaders = Object.keys(firstItem!)
    const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
    // Transform data to match headers (Simplified)
    const transformedData = type?.map((item: any) => {
      const transformedItem: Record<string, string> = {};
      originalHeaders.forEach((originalKey, idx) => {
        const upperKey = upperHeaders[idx];
        transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
      });
      return transformedItem;
    });
    // Convert data to CSV format
    const csvData = Papa.unparse({
      fields: upperHeaders,
      data: transformedData!,
    })
    // Create a Blob and download link
    const blob = new Blob([csvData], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    // Create a download link
    const a = document.createElement("a")
    a.href = url
    a.download = `${"payment-orders"}.csv`
    document.body.appendChild(a)
    // Trigger a click on the link to start the download
    a.click()
    // Cleanup
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }

  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [userData, stateUser?.colors])


  React.useEffect(() => {
    if (defaultValues) {
      Object.entries(defaultValues).forEach(([key, value]) => {
        setValue(key as keyof typeof defaultValues, value)
      })
    }
  }, [defaultValues])

  const handleDelete = async () => {
    setOpenDrawer(false)
    try {
      setLoading(true)
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/auth/delete-admin`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${stateToken}`,
          },
          body: JSON.stringify({
            admin_id: selectedRow?.admin_id,
          }),
        }
      )

      const req = await response.json()

      if (response.ok) {
        toast.success("Admin deleted successfully")
        SetShowDeleteModal(false)
        if (user?.email === selectedRow?.email) {
          localStorage.clear()
          history?.push("/")
          //()
        }
      } else {
        toast.error(req?.msg)
      }
      setLoading(false)
    } catch (error) {
      toast.error("Error deleting admin")
      setLoading(false)
    }
  }

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked && paginatedData) {
      const allRows = paginatedData.map((item) => item.id)
      setSelectedRows(allRows)
    } else {
      setSelectedRows([])
    }
  }

  const handleRowCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    rowId: string
  ) => {
    if (event.target.checked) {
      setSelectedRows([...selectedRows, rowId])
    } else {
      setSelectedRows(selectedRows.filter((id) => id !== rowId))
    }
  }

  const handleCreateSinglePaymentOrder = async (data: any) => {

    try {
      setLoadingCreating(true)
      setLoadingRow(data)
      const payload = JSON.stringify(
        {
          policy_id: data?.policy_id,
          amount: data?.amount_requisitioned,
          transaction_id: data?.provider_transaction_id,
          reference: data?.reference,
          user_id: data?.payee_id

        },
    )

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/create-single-payment-v2?company_id=${companyId}&usertype=${DASHBOARD_USERTYPE.company}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${stateToken}`,
          },
          body: payload, // Place the body outside the headers object
        }
      )

      const req = await response.json()
      setLoadingCreating(false)
      if (response.ok) {
        refetchRequisition()
        toast.success("Payment paid successfully")
      } else {
        toast.error(req?.msg)
      }
      setLoadingCreating(false)
    } catch (error) {
      toast.error("Error making payment")
      setLoading(false)
    }
  }

  const handleCreateMultiplePaymentOrder = async () => {
    try {
      setLoadingCreating(true)

      const payload = paginatedData?.filter(item => selectedRows.includes(item.id))
        .map(row => ({
          policy_id: row.policy_id,
          amount: row.amount_requisitioned,
          transaction_id: row.provider_transaction_id,
          reference: row.reference,
          user_id: row.payee_id
        }));

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/create-payment-approval-v2?company_id=${companyId}&usertype=${DASHBOARD_USERTYPE.company}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${stateToken}`,
          },
          body: JSON.stringify(payload),
        }
      )

      const req = await response.json()
      setLoadingCreating(false)
      if (response.ok) {
        toast.success("Payment made successfully")
        refetchRequisition()
      } else {
        toast.error(req?.msg)
      }
      setLoadingCreating(false)
    } catch (error) {
      toast.error("Error making payment")
      setLoading(false)
    }
  }


  const handleCreateMultiplePaymentOrderv2 = async () => {
    try {
      const payload = paginatedData
        ?.filter(item => selectedRows.includes(item.id))
        .map(row => ({
          policy_id: row.policy_id,
          amount: row.amount_requisitioned,
          transaction_id: row.provider_transaction_id,
          reference: row.reference,
          user_id: row.payee_id,
        }))

      setBgTaskStatus({
        running: true,
        total: payload ? payload.length : 0,
        processed: 0,
        success: 0,
        failed: 0,
      })
      

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/create-payment-approval-v2?company_id=${companyId}&usertype=${DASHBOARD_USERTYPE.company}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${stateToken}`,
          },
          body: JSON.stringify(payload),
        }
      )

      const data = await response.json()
      if (!response.ok) throw new Error(data?.msg || "Failed to start task")

      toast.info("Payment task started. Processing in background...")

      const parentTaskId = data.task_id
      const pollInterval = 5000 // 5 seconds

      const pollTaskStatus = async () => {
        const statusRes = await fetch(
          `${process.env.REACT_APP_BASE_URL}/check-payment-tasks/${parentTaskId}`,
          { headers: { Authorization: `Bearer ${stateToken}` } }
        )

        const statusData = await statusRes.json()
        const tasks = statusData.tasks || []

        const total = tasks.length
        const success = tasks.filter((t: any) => t.state === "SUCCESS").length;
        const failed = tasks.filter((t: any) => t.state === "FAILURE").length;

        const processed = success + failed

        // Update progress
        setBgTaskStatus({
          running: statusData.parent_state !== "SUCCESS" && processed < total,
          total,
          processed,
          success,
          failed,
        })

        // ✅ When all tasks done
        if (processed === total && total > 0) {
          toast.success(
            `Payment task completed! ${success} succeeded, ${failed} failed.`
          )
          refetchRequisition()
        } else {
          // ⏳ Continue polling
          setTimeout(pollTaskStatus, pollInterval)
        }
      }

      pollTaskStatus()
    } catch (error: any) {
      toast.error(error.message || "Error starting payment task")
      setBgTaskStatus(prev => ({ ...prev, running: false }))
    }
  }



  React.useEffect(() => {
    const data = localStorage.getItem("user")
    if (data) {
      setUser(JSON.parse(data))
    }
  }, [])
  return (
    <>
      <CustomDeleteModal
        open={showDeleteModal}
        onClose={() => SetShowDeleteModal(false)}
        onSubmit={handleDelete}
        loading={loading}
        title="Delete selected admin"
      />
      <DetailDrawer
        size={450}
        title="Payment detail"
        open={open}
        children={<>{<PaymentOrderDetail content={selectedRowss} />}</>}
        onClose={() => setOpen(false)}
      />

      <ConfirmationDialog
        show={showConfirmation}
        setShow={setShowConfirmation}
        onConfirm={() => setOpenOtp(true)}
      />
      <DriverModal
        title="Enter Your PIN"
        open={openOtp}
        size={"sm"}
        focus="message"
        onClose={() => setOpenOtp(false)}
        children={
          <Otp
            onConfirm={() =>
              requestType === "approve"
                ? handleCreateSinglePaymentOrder(chosenId)
                : requestType === "disapprove"
                  ? setOpenSendDispproveMsg(true)
                  : handleCreateMultiplePaymentOrderv2()
            }
            onClose={() => setOpenOtp(false)}
          />
        }
      // () => handleCreateSinglePaymentOrder(chosenId)
      />
      <DriverModal
        title={
          <p className=" text-gray-800 text-[1.2rem]">Disapprove Order?</p>
        }
        open={openSendDispproveMsg}
        size={400}
        focus="message"
        onClose={() => setOpenSendDispproveMsg(false)}
        children={
          <DisApproveOrdres
            driver={""}
            onClose={() => setOpenSendDispproveMsg(false)}
            onConfirm={() => refetchRequisition()}
            getRequisitionId={requisitionId}
          />
        }
      />

      <DetailDrawer
        size={350}
        title="Admin detail"
        open={openDrawer}
        children={<>{/* <RenderAdminDetail content={selectedRow} /> */}</>}
        onClose={() => setOpenDrawer(false)}
      />

      <CustomHeader title="Payment Orders" />

      {bgTaskStatus.running && (
        <div className="mb-4 p-4 bg-gray-800 rounded-lg shadow-md">
          <p className="text-white mb-2 font-medium">
            Processing payments:{" "}
            <span className="text-blue-400">
              {bgTaskStatus.processed}/{bgTaskStatus.total}
            </span>
          </p>

          <div className="w-full bg-gray-700 rounded-full h-3">
            <div
              className="bg-gradient-to-r from-blue-400 to-blue-600 h-3 rounded-full transition-all duration-500"
              style={{
                width: `${(bgTaskStatus.processed / bgTaskStatus.total) * 100}%`,
              }}
            />
          </div>

          <p className="text-gray-400 text-sm mt-1">
            ✅ {bgTaskStatus.success} succeeded | ❌ {bgTaskStatus.failed} failed
          </p>
        </div>
      )}

      {!bgTaskStatus.running && bgTaskStatus.total > 0 && (
        <div className="mb-4 p-4 bg-gray-800 rounded-lg shadow-md">
          <p className="text-white mb-2 font-medium">
            Task completed! ✅{" "}
            <span className="text-green-400">{bgTaskStatus.success}</span> succeeded, ❌{" "}
            <span className="text-red-400">{bgTaskStatus.failed}</span> failed
          </p>
          <button
            onClick={() => refetchRequisition()}
            className="mt-2 bg-blue-500 hover:bg-blue-600 text-white py-1 px-3 rounded"
          >
            Refresh Data
          </button>
        </div>
      )}


      <div className="mt-10">
        <CardBody className="shadow-sm sticky px-0 py-0  rounded-3xl w-full">
          <div className="bg-black pt-5 rounded-t-2xl">
            <Typography
              variant="h6"
              style={{
                color:
                  colors?.length! > 1
                    ? `${colors![0]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`,
              }}
              className="px-4 pb-4  font-bold leading-none opacity-70 capitalize"
            >
              List of All Outstanding Payments Orders
              {requisition?.view_payment_requistion_details && (
                <span className="text-white text-sm bg-admin-red p-1 rounded-md">
                  {totalItems?.length}{" "}

                </span>
              )}
            </Typography>
          </div>
          <div className="w-full">
            <div className="w-full  flex flex-col gap-y-4 bg-white p-3">
              <div className="flex shrink-0 flex-col gap-2 justify-end sm:flex-row pl-10">
                <Tooltip content="Export as CSV">
                  <Button
                    onClick={handleDownload}
                    variant="filled"
                    className="capitalize text-sm font-normal flex flex-wrap gap-2"
                    size="sm"
                  >
                    <FiDownloadCloud size={20} />
                    <span>Download csv</span>
                  </Button>
                </Tooltip>
              </div>
              <div className="p-3 flex gap-x-2 items-center flex-col 2xl:flex-row gap-y-3 mb-5">
                {selectedRows?.length > 0 && (
                  <Button
                    // onClick={() => handleCreateMultiplePaymentOrder()}
                    onClick={() => {
                      setRequestType("multiple")
                      setOpenOtp(true)
                    }}
                    size="sm"
                    color="teal"
                    className="text-xs font-normal capitalize bg-brand-cyan w-64"
                  >
                    {loadingCreating ? "loading..." : "Approve payment"}
                  </Button>
                )}
                {/* <div className="w-full flex flex-row gap-x-2">
                  <Input
                    crossOrigin="anonymous"
                    label="Search"
                    value={requistionText}
                    onChange={(e) => {
                      setRequistionSearch(e.target.value)
                      if (e.target.value === "") {
                        setRequistionSearch("")
                        setSearchData(undefined)
                        setSearchFilterStart("")
                        setSearchFilterEnd("")
                      }
                    }}
                    icon={<i className="fas fa-search text-base"></i>}
                  />
                  <Button
                    onClick={handleRequistionSerach}
                    variant="filled"
                    className="capitalize text-sm font-normal flex flex-wrap gap-2 justify-center items-center"
                    size="sm"
                  >
                    <span>Search</span>
                  </Button>
                </div> */}

                {/* <div className="flex flex-col xl:flex-row gap-3 justify-between mb-0">
                  <div className="flex items-center space-x-2">
                    <label className="font-semibold text-gray-700">From</label>
                    <Input
                      type="datetime-local"
                      value={tempStartDate} // Remove 'Z' for input value
                      onChange={handleTempStartDateChange}
                      size="md"
                      className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <label className="font-semibold text-gray-700">To</label>
                    <Input
                      type="datetime-local"
                      value={tempEndDate} // Remove 'Z' for input value
                      onChange={handleTempEndDateChange}
                      size="md"
                      className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <Tooltip content="Apply Date Filters">
                      <Button
                        onClick={handleDateChange}
                        variant="filled"
                        className="capitalize text-sm font-normal flex flex-wrap gap-2"
                        size="sm"
                      >
                        <span>Filter</span>
                      </Button>
                    </Tooltip>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Tooltip content="Clear All Date filters">
                      <Button
                        onClick={reset}
                        variant="filled"
                        className="capitalize text-sm font-normal flex flex-wrap gap-2"
                        size="sm"
                      >
                        <span>Clear</span>
                      </Button>
                    </Tooltip>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <CardBody className="px-0 py-0">
            <div
              className="overflow-x-auto overflow-y-auto"
              style={{ maxHeight: "65vh" }}
            >
              <table className="w-full bg-white min-w-max table-auto">
                <thead className="bg-white sticky z-50 top-0">
                  <tr>
                    <th className="border-y border-blue-gray-100 text-black bg-gray-50/50 p-4">
                      <input
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={selectedRows.length === paginatedData?.length}
                      />
                    </th>
                    {[
                      "Payment Transaction Type",
                      "Transaction Reference",
                      "Provider Transaction Id",
                      "Policy Details",
                      "Payee Details",
                      "Payment Details",
                      "Account Details",
                      "Momo Details",
                      "Date Created",
                      "Amount",
                      "",
                      "",
                    ].map((head) => (
                      <th
                        key={head}
                        className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                      >
                        <Typography
                          color="black"
                          className="font-bold text-sm text-black leading-none opacity-70 capitalize"
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginatedData?.map((item, index: number) => {

                    const isLast = index === paginatedData?.length - 1
                    const classes = isLast
                      ? "px-2 py-4  text-center"
                      : "px-2 py-4 border-b-2 border-blue-gray-50 text-center"

                    return (
                      <tr
                        key={item?.id + index.toString()}
                        onClick={() => {
                          setSelectedRowss(item)
                          setOpen(true)
                        }}
                        className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                      >
                        <td className={classes}>
                          <input
                            onClick={(e) => {
                              e.stopPropagation()
                            }}
                            type="checkbox"
                            onChange={(event) =>
                              handleRowCheckboxChange(event, item.id)
                            }
                            checked={selectedRows.includes(item.id)}
                          />
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize "
                          >
                            {item?.transaction_type}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.reference}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.provider_transaction_id}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Policy Number:{" "}
                            <span className="font-normal">
                              {item?.policy_number}
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Class/Subclass:{" "}
                            <span className="font-normal">
                              {item?.business_class_name +
                                " / " +
                                item?.sub_class_name}
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Risk ID.:{" "}
                            <span className="font-normal">{item?.risk_id}</span>
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Client Name:{" "}
                            <span className="font-normal">
                              {item?.payee_name}
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Client Type:{" "}
                            <span className="font-normal">
                              {item?.payee_type}
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Phone No.:{" "}
                            <span className="font-normal">
                              {item?.payee_number}
                            </span>
                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            transaction_type:{" "}
                            <span className="font-normal">
                              {item?.transaction_type}
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Reference Amount:{" "}
                            <span className="font-normal">
                              {item?.reference_amount}
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Rate:{" "}
                            <span className="font-normal">{item?.rate} %</span>
                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Bank:{" "}
                            <span className="font-normal">
                              {
                                parseRequisitionData(item).account_details
                                  .bank_name
                              }
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Branch:{" "}
                            <span className="font-normal">
                              {
                                parseRequisitionData(item).account_details
                                  .branch
                              }
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            A/C No:{" "}
                            <span className="font-normal">
                              {
                                parseRequisitionData(item).account_details
                                  .acct_number
                              }
                            </span>
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Network:{" "}
                            <span className="font-normal">
                              {parseRequisitionData(item).momo_details.network}
                            </span>
                          </Typography>

                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize text-left pl-7"
                          >
                            Wallet No:{" "}
                            <span className="font-normal">
                              {parseRequisitionData(item).momo_details.number}
                            </span>
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {moment(item?.created_at).format("LL")}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {"GHS " +
                              (item.amount_requisitioned ?? 0).toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                          </Typography>
                        </td>
                        <div className="flex justify-between whitespace-nowrap z-50 bg-white sticky right-0">
                          <td className={classes}>
                            <Button
                              onClick={(e) => {
                                e.stopPropagation()
                                setChosenId(item)
                                setShowConfirmation(true)
                                setRequestType("approve")
                              }}

                              size="sm"
                              disabled={loadingRow === item?.id}
                              color="teal"
                              className="text-xs font-normal capitalize bg-brand-cyan"
                            >
                              {loadingRow === item.id
                                ? "Loading"
                                : "Approve Order"}

                              {/* {loadingRow === item.payable_commission_id ? "Loading" : "Request to pay"} */}
                            </Button>
                          </td>
                          <td className={classes}>
                            <Button
                              onClick={(e) => {
                                e.stopPropagation()
                                setRequisitionId(item?.policy_id)
                                setOpenOtp(true)
                                setRequestType("disapprove")
                                // setOpenSendDispproveMsg(true)
                                // setShowConfirmation(true)
                              }}
                              // onClick={() => { setChosenId(item?.payable_commission_id); setShowConfirmation(true); }}
                              size="sm"
                              disabled={loadingRow === item?.id}
                              color="red"
                              className="text-xs font-normal capitalize bg-brand-cyan"
                            >
                              {loadingRow === item.id
                                ? "Loading"
                                : "Disapprove Order"}

                              {/* {loadingRow === item.payable_commission_id ? "Loading" : "Request to pay"} */}
                            </Button>
                          </td>
                        </div>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </CardBody>
        </CardBody>

        {(loadingRequistion || isFilterLoading) && (
          <div className="mt-10 flex items-center justify-center">
            <Spinner className="w-10 h-10" />
          </div>
        )}

        {paginatedData?.length! === 0 && !loadingRequistion && !isFilterLoading && (
          <div className="mt-10 flex items-center justify-center">
            <Typography color="white" variant="h6">
              No data found
            </Typography>
          </div>
        )}

        {paginatedData?.length !== 0 && !loadingRequistion && !isFilterLoading && (
          // <GeneralPagination
          //   totalItems={totalItems?.length!}
          //   itemsPerPage={itemsPerPage}
          //   currentPage={currentPage}
          //   onPageChange={handlePageChange}
          // />

          <PerPageAndPagination
            customColor="white"
            total={totalItems?.length!}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            perPage={itemsPerPage}
            setPerPage={setItemsPerPage}
          />
        )}
        {/* {isLoading && (
          <div className="mt-10 flex items-center justify-center">
            <Spinner className="w-1o h-10" />
          </div>
        )} */}

        {/* {!paginatedData && !isLoading && (
          <div className="mt-10 flex items-center justify-center">
            <Typography color="white" variant="h6">
              No data found
            </Typography>
          </div>
        )} */}

        {/* Paginator */}
        {/* {paginatedData && (
          <div className="my-10 flex items-center justify-center">
            <div className="flex items-center gap-8">
              <IconButton
                size="sm"
                variant="outlined"
                onClick={prevPage}
                disabled={activeRequistionPage === 1}
              >
                <AiOutlineArrowLeft strokeWidth={2} className="h-4 w-4" />
              </IconButton>
              <Typography color="gray" className="font-normal">
                Page{" "}
                <strong className="text-gray-900">
                  {activeRequistionPage}
                </strong>{" "}
                of{" "}
                <strong className="text-gray-900">
                  {Math.ceil(
                    (data?.admins?.filter(filterData).length || 0) / PAGE_SIZE
                  )}
                </strong>
              </Typography>
              <IconButton
                size="sm"
                variant="outlined"
                onClick={nextPage}
                disabled={
                  activeRequistionPage ===
                  Math.ceil(
                    (data?.admins?.filter(filterData).length || 0) / PAGE_SIZE
                  )
                }
              >
                <AiOutlineArrowRight strokeWidth={2} className="h-4 w-4" />
              </IconButton>
            </div>
          </div>
        )} */}
      </div>
    </>
  )
}

export default PaymentOrders
